import { render, staticRenderFns } from "./tb_view.vue?vue&type=template&id=2ec2749e&scoped=true"
import script from "./tb_view.vue?vue&type=script&lang=js"
export * from "./tb_view.vue?vue&type=script&lang=js"
import style0 from "./tb_view.vue?vue&type=style&index=0&id=2ec2749e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2749e",
  null
  
)

export default component.exports